module.exports = __webpack_public_path__ + "fonts/GothamNarrow-Book.0b3a6e64.ttf";